import { createQueryKeyStore } from "@lukemorales/query-key-factory";

export const patientReceptionKeys = createQueryKeyStore({
  patientReception: {
    detail: (familyAccountId) => [familyAccountId],
  },
});
